<template>
  <div>
    <div
      class="btn-wrapper d-flex justify-content-md-end justify-content-center"
    >
      <button
        class="btn btn-outline-primary wizard-btn prev-btn"
        @click="previous"
      >
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
        {{ $t("global.return") }}
      </button>
      <button
        class="btn btn-primary wizard-btn next-btn"
        @click="nextStep"
        :disabled="!dateRange.from || !dateRange.to"
      >
        {{ $t("global.next") }}
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
    </div>
    <div class="row mb-4 mt-3">
      <div class="col-md-6 mb-3">
        <div class="card custom-card">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <h5>{{ $t("days.off.request.step.three.title") }}</h5>
              <fieldset class="mt-0">
                <d-form-radio
                  v-model="type"
                  :value="daysOffType.CP.value"
                  checked
                  class="mb-3"
                  >{{ daysOffType.CP.name }}</d-form-radio
                >
                <d-form-radio
                  v-model="type"
                  :value="daysOffType.CS.value"
                  class="mb-3"
                  >{{ daysOffType.CS.name }}</d-form-radio
                >
                <d-form-radio
                  v-model="type"
                  :value="daysOffType.OTHER.value"
                  class="mb-3"
                  >{{ daysOffType.OTHER.name }}</d-form-radio
                >
              </fieldset>
              <div v-if="type === daysOffType.OTHER.value" class="mt-3">
                <!-- <h5>{{ $t("days.off.request.step.three.motif") }}</h5> -->
                <textarea
                  class="form-control mt-4"
                  v-model="motif"
                  cols="30"
                  rows="7"
                  :placeholder="$t('days.off.request.step.four.explainPlaceHolder')"
                ></textarea>
                <errors field="motifOther" :errors="errors"></errors>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card custom-card">
          <div class="card-body">
            <div class="py-2 px-3">
              <h5>{{ $t("days.off.request.step.four.title") }}</h5>
              <div class="mt-1 d-flex flex-column">
                <div class="row">
                  <div class="col-12 col-lg-6 jjj">
                    <h6 slot="afterDateInput" class="mr-2">Du *</h6>
                    <d-datepicker
                      id="datepicker"
                      style="width: 220px;"
                      class="mr-5 mb-3"
                      v-model="dateRange.from"
                      :highlighted="{
                        from: dateRange.from,
                        to: dateRange.to || new Date()
                      }"
                      :disabledDates="disabledDatesFrom"
                      placeholder="Date de debut"
                      @input="checkDates"
                      :input-class="['form-control', 'datepicker']"
                      :language="fr"
                      small
                    ></d-datepicker>
                    <div class="d-inline" v-if="dateRange.from !== null">
                      <div>Je souhaite prendre le </div>
                      <u>{{ dateFrom }}</u>
                      <template v-if="dateRange.fromWhichHalf">en</template> :
                      <select
                        v-model="dateRange.fromWhichHalf"
                        class="mt-2 form-control d-inline"
                        @change="selectHalf"
                      >
                        <option
                         v-for="(type, index) in dayTypes"
                         :value="index"
                        >
                         {{ type }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 jjj">
                    <h6 slot="afterDateInput" class="mr-2">Au *</h6>
                    <d-datepicker
                      class="mb-3"
                      style="width: 220px;"
                      v-model="dateRange.to"
                      :highlighted="{
                        from: dateRange.from,
                        to: dateRange.to || new Date()
                      }"
                      :disabledDates="disabledDatesTo"
                      placeholder="Date de fin"
                      @input="checkDates"
                      :input-class="['form-control', 'datepicker']"
                      :language="fr"
                      small
                    ></d-datepicker>
                    <div class="d-inline mt-2" v-if="dateRange.to !== null">
                      <div>Jusqu'au</div>
                      <u>{{ dateTo }}</u> :
                      <select
                        v-if="dateFrom != dateTo"
                        v-model="dateRange.toWhichHalf"
                        class="mt-2 form-control d-inline"
                      >
                        <option
                         v-for="(type, index) in dayTypes"
                         :value="index"
                        >
                         {{ type }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  semiDay && dateRange.from !== null && dateRange.to !== null
                "
                class="mt-5"
              >
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import daysOffType from '../../../data/daysOff/daysOffType.js';
import Errors from '../../error/errors';
import ErrorsHelper from '../../../helper/ErrorsHelper';
import TimeUtils from '../../../utils/TimeUtils';
import { fr } from 'vuejs-datepicker/dist/locale';
import $ from 'jquery';

export default {
  name: 'StepThree',
  components: { Errors },
  props: ['user'],
  data() {
    return {
      type: 'CP',
      daysOffType,
      motif: '',
      errors: {},
      dayTypes: ['Toute la journée', 'Matinée - Demi journée', 'Après-midi- Demi journée'],
      requiredFields: ['motifOther'],
      dateRange: {
        from: null,
        fromWhichHalf: 0,
        to: null,
        toWhichHalf: 0,
      },
      disabledDatesFrom: {
        to: new Date(),
      },
      inputclass: true,
      semiDay: false,
      fr,
    };
  },
  async created() {
    const datepickers = await document.getElementsByClassName('datepicker');
    for (let i = 0; i < datepickers.length; i++) {
      console.log(datepickers[i]);
      datepickers[i].style.cursor = 'pointer';
    }
  },
  computed: {
    disabledDatesTo() {
      return {
        to: this.dateRange.from || new Date(),
      };
    },

    dateFrom() {
      return TimeUtils.formatFullDay(this.dateRange.from);
    },

    dateTo() {
      return TimeUtils.formatFullDay(this.dateRange.to);
    },
  },
  methods: {
    previous() {
      this.$emit('input', null);
    },
    checkDates() {
      if (this.dateRange.to < this.dateRange.from) {
        this.dateRange.to = null;
      }
    },
    selectHalf() {
      if (this.dateFrom == this.dateTo) {
        this.dateRange.toWhichHalf = this.dateRange.fromWhichHalf;
      }
    },

    nextStep() {
      this.selectHalf();
      this.errors = {};
      if (this.type === this.daysOffType.OTHER.value) {
        const model = {
          type: this.type,
          motifOther: this.motif,
          semiDay: this.semiDay,
          dateRange: this.dateRange,
        };
        if (ErrorsHelper.checkErrors(this.requiredFields, model, this.errors)) {
          this.$emit('input', model);
        }
      } else {
        this.$emit('input', {
          type: this.type,
          semiDay: this.semiDay,
          dateRange: this.dateRange,
        });
      }
    },
  },
};
</script>

<style scoped>
.card {
  position: relative;
  background-color: transparent;
}
.wizard-btn-wrapper {
  position: absolute;
  top: -120px;
  right: 0;
}
.custom-card {
  background-color: #ffffff;
}
.custom-datepicker input {
  border: none !important;
  background-color: #b6bbdd !important;
  color: #007bff !important;
  border-radius: 15px !important;
  width: 50% !important;
  text-align: center !important;
  font-weight: 600 !important;
}
</style>
